import script from "./TopKPIs.vue?vue&type=script&setup=true&lang=js"
export * from "./TopKPIs.vue?vue&type=script&setup=true&lang=js"

import "./TopKPIs.vue?vue&type=style&index=0&id=e015ba8c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e015ba8c"]])

export default __exports__